import { Box, Typography } from "@mui/material";
import React from "react";
import type { RoleFaqsOutcomes } from "../../content/roleFaqsContent";
import { Reveal } from "../../theme/animation";

interface OutcomesSectionProps {
  outcomes: RoleFaqsOutcomes;
  id?: string;
}

const OutcomesSection: React.FC<OutcomesSectionProps> = ({
  outcomes,
  id = "outcomes",
}) => {
  return (
    <Box id={id} component="section" sx={{ mb: 6 }}>
      <Reveal variant="fadeUp">
        <Typography variant="h4" component="h2" sx={{ mb: 3, fontWeight: "bold" }}>
          Expected Outcomes
        </Typography>
      </Reveal>
      <Reveal variant="fadeUp" delay={0.08}>
        <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 2 }}>
          {outcomes.description}
        </Typography>
      </Reveal>
      {outcomes.problemSolved && (
        <Reveal variant="fadeUp" delay={0.12}>
          <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
            Problem Solved:
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
            {outcomes.problemSolved}
          </Typography>
          </Box>
        </Reveal>
      )}
      {outcomes.outcomeMetrics && outcomes.outcomeMetrics.length > 0 && (
        <Reveal variant="fadeUp" delay={0.16}>
          <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Outcome Metrics:
          </Typography>
          {outcomes.outcomeMetricsIntro && (
            <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 1 }}>
              {outcomes.outcomeMetricsIntro}
            </Typography>
          )}
          <Box component="ul" sx={{ pl: 3, m: 0 }}>
            {outcomes.outcomeMetrics.map((m, i) => (
              <li key={i}>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                  {m}
                </Typography>
              </li>
            ))}
          </Box>
          {outcomes.outcomeMetricsNote && (
            <Typography variant="body1" sx={{ lineHeight: 1.8, mt: 1.5 }}>
              {outcomes.outcomeMetricsNote}
            </Typography>
          )}
          </Box>
        </Reveal>
      )}
    </Box>
  );
};

export default OutcomesSection;
